import { Component, inject } from '@angular/core';
import { ModalComponent } from '../../../services/modal/modal.component';
import { MODAL_REF } from '../../../services/modal/modal.service';
import { ButtonComponent } from '@infinitform/shared-ui';

@Component({
    selector: 'app-example-project-copy-modal',
    template: `
    <app-modal>
      <div class="if-modal-title">This is an Example Project</div>
      <div class="if-modal-content if-modal-content-center">
        <div class="example-project-message">To make changes, copy this project to your account first.</div>
      </div>
      <div class="if-modal-actions">
        <app-button (click)="cancel()" variant="ghost">Cancel</app-button>
        <app-button (click)="copyToMyProjects()" variant="primary">Copy to My Projects</app-button>
      </div>
    </app-modal>
  `,
    styles: [`
    .example-project-message {
      text-align: center;
      font-size: 14px;
      line-height: 1.5;
      color: var(--black, #333);
    }
  `],
    imports: [ModalComponent, ButtonComponent]
})
export class ExampleProjectCopyModalComponent {
  private modalRef = inject(MODAL_REF);

  copyToMyProjects(): void {
    this.modalRef.close('copy');
  }

  cancel(): void {
    this.modalRef.close('cancel');
  }
}
